import React, { Component } from 'react';
import Publicnav from "./publicNav.js"
import "./news.css"
import Publicleft from "./publicleft.js"
import  Notices from "./notiecs.js"
class News extends Component {
    constructor(props){
        super(props)  
        this.state ={
            pamaschange : "",
            public : [],
            notification :[],
            noerorrpage :  true
        }
    }

   componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
     const { match: { params } } = this.props;
     console.log("params.userId",params.id)
     this.setState({
         pamaschange : params.id
     })

            this.setState({
                noticepop : false,
                loadingnews :true
            })
            console.log("public users id", this.state.pamaschange)
            // console.log("get payment",  Auth.getProfile().userId)
            const requestOptions = {
                method: 'GET', 
                headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
            };
            console.log("public users param", params.id)
            fetch("https://uvunebeta.herokuapp.com/users/"+params.id, requestOptions)
            .then(res => res.json())
            .then((result)=>{
                if(result){
                    console.log("public users", result)
                    this.setState({
                        loadingnews :false,
                        public : result
                    })

                    fetch("https://uvunebeta.herokuapp.com/notifications?created_by="+ params.id, requestOptions)
                    .then(res => res.json())
                    .then((result)=>{
                      if(result){
                          console.log("result notification", result.data)
                          this.setState({
                              loadingedit:true,
                              noticeshow : true,
                              notification:result.data,
                           //    check : false
                          })
                         //  this.getData(result)
                         
                      }else{
                       check : true
                      }
                    }).catch( (error) => {
                      //  console.log("errro", error);
                       console.log("error load", error )
                  });
                }else{
                    this.setState({
                        lloadingnews  :true
                    }) 
                }
            })
        } 
        
  render() {
 
    return (
        <div className="public-body-container"> 
        <br/>
       <br/>
      <div className="container is-fluid body-public">
      <div className="columns">

              <Publicleft name={this.state.public.display_name} image={this.state.public.image_url} address={this.state.public.address} />  
                     
           <div className="column">
                  <Publicnav  id={this.state.pamaschange} />
             
              <hr/>
               <div className="">
               <div className="tuition-body"> 
                   <div className="tuition-titlie-sub"> 
                   <i className="far fa-newspaper icon-link"></i>  Notification
                       
                   </div>
                   <div> 
                     <div className="news-notification-publie-body">
                      <div className="info-body">

                      {
                                    
                            this.state.notification.length > 0 ? (
                                <div>
                                    {

                                        this.state.notification.map( notice=>{
                                            return(
                                                < Notices
                                                key={notice._id}
                                                date={notice.createdAt}
                                                body={notice.body}
                                                title={notice.title}
                                                name={this.state.public.display_name}
                                                id={notice._id}
                                                />
                                            )

                                        })  
                                    }
                             </div>
                              ) :
                               ( <span>No notification</span>)
                            } 
                       </div>
                      </div> 
                   </div>
               </div>
                     
              </div>     

           </div>
           <div className="column  is-one-third">
           <div className="app-list">
                      <div className="title-head-public">
                                     <b> 
                                     <i className="far fa-newspaper icon-link"></i>Wellcome to uvune
                                     </b> 
                         </div> 
                         <div className="notice-add-body">
                            <div className="notice-add">
                            <img   src="http://res.cloudinary.com/easywaya/image/upload/v1535448295/1fcb38eb-fed4-47ca-abbe-babab288e041_p5mphs.jpg"  />
                            </div>   
                         </div>   
                         
                 </div>
           
           </div>
         </div>
     </div>

</div>     
    )

}





}

export default News;


// WEBPACK FOOTER //
// ./src/component/public/news.js